import { resolveWorkoutOverviewStatusFilterVariant } from '~/utils/workoutOverviewStatus';

export const WORKOUT_COMPLETED_SUBSTATUS_FILTERS = [
  {
    value: 'completedNeedsAttention',
    shortLabel: 'Требует внимания тренера',
  },
  {
    value: 'completedUnreviewed',
    shortLabel: 'Не проверена',
  },
  {
    value: 'completedReviewed',
    shortLabel: 'Проверена',
  },
];

export const ALL_WORKOUT_STATUS_FILTER_VALUES = [
  'draft',
  'ready',
  'inProgress',
  'completed',
  'cancelled',
  ...WORKOUT_COMPLETED_SUBSTATUS_FILTERS.map((item) => item.value),
];

const COMPLETED_SUBSTATUS_VALUES = new Set(
  WORKOUT_COMPLETED_SUBSTATUS_FILTERS.map((item) => item.value),
);

/**
 * @param {string} value
 */
export function isWorkoutCompletedSubstatusFilterValue(value) {
  return COMPLETED_SUBSTATUS_VALUES.has(value);
}

/**
 * @param {string} value
 */
export function normalizeWorkoutOverviewStatusFilterValue(value) {
  return value;
}

/**
 * @param {{
 *   ent_is_completed?: boolean,
 *   workout_has_remarks?: boolean,
 *   workout_analysis_confirmed?: boolean,
 *   workout_result_checked?: boolean,
 * }|null|undefined} source
 * @returns {'completedNeedsAttention'|'completedUnreviewed'|'completedReviewed'|null}
 */
export function resolveWorkoutCompletedSubstatus(source) {
  if (!source?.ent_is_completed) {
    return null;
  }

  if (source.workout_analysis_confirmed) {
    return 'completedReviewed';
  }

  if (source.workout_has_remarks && !source.workout_analysis_confirmed) {
    return 'completedNeedsAttention';
  }

  return 'completedUnreviewed';
}

/**
 * @param {string} substatusValue
 * @returns {Record<string, unknown>|null}
 */
export function resolveWorkoutCompletedSubstatusFilterIconProps(substatusValue) {
  if (substatusValue === 'completedNeedsAttention') {
    return {
      cornerDot: true,
    };
  }

  if (substatusValue === 'completedReviewed') {
    return {
      nestedFrame: true,
    };
  }

  return null;
}

/**
 * @param {{
 *   ent_is_completed?: boolean,
 *   workout_has_remarks?: boolean,
 *   workout_analysis_confirmed?: boolean,
 *   workout_result_checked?: boolean,
 * }|null|undefined} source
 * @returns {Record<string, unknown>|null}
 */
export function resolveWorkoutCompletedSubstatusIconPropsFromSource(source) {
  const substatus = resolveWorkoutCompletedSubstatus(source);
  if (!substatus) {
    return null;
  }

  return resolveWorkoutCompletedSubstatusFilterIconProps(substatus);
}

/**
 * @param {Record<string, unknown>|null|undefined} workout
 * @param {(workout: Record<string, unknown>) => Record<string, unknown>|null|undefined} buildSourceFromWorkout
 * @returns {string[]}
 */
export function resolveWorkoutStatusFilterKeys(workout, buildSourceFromWorkout) {
  const variant = resolveWorkoutOverviewStatusFilterVariant(workout, buildSourceFromWorkout);
  if (!variant) {
    return [];
  }

  const keys = [variant];
  if (variant !== 'completed') {
    return keys;
  }

  const source = buildSourceFromWorkout ? buildSourceFromWorkout(workout) : workout;
  const substatus = resolveWorkoutCompletedSubstatus(source);
  if (substatus) {
    keys.push(substatus);
  }

  return keys;
}
